var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsurer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49984 6.10643H1.24243V15.9487H6.49984V6.10643Z",
    fill: "#22AAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.413 6.10643H14.1556V15.9487H19.413V6.10643Z",
    fill: "#1694A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6273 18.0967H19.8046C19.9124 18.0967 20 18.0092 20 17.9015V5.04128C20 4.79146 19.7978 4.58952 19.5477 4.58952H14.6123V6.71294H18.3691V7.66807H14.6123V8.30532H18.3691V9.2612H14.6123V9.89845H18.3691V10.8543H14.6123V11.4916H18.3691V12.4475H14.6123V13.0847H18.3691V14.0406H14.6123V14.6778H18.3691V15.6337H14.6123V16.271H14.6273V17.2261H14.6123V17.4146H14.6273V18.0967Z",
    fill: "#137D9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9828 4.59333H14.1321V18.1005H14.9828V4.59333Z",
    fill: "#0B5D77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38771 18.1005V16.0145H5.3892V15.6345H1.63091V14.6787H5.38771V14.0414H1.63091V13.0855H5.38771V12.4483H1.63091V11.4924H5.38771V10.8551H1.63091V9.89927H5.38771V9.26202H1.63091V8.30913H5.38771V7.67188H1.63091V6.71675H5.38771V4.59333H0.452285C0.202182 4.59333 0 4.79528 0 5.04509V17.9053C0 18.013 0.0876099 18.1005 0.195439 18.1005H5.38771V18.1005Z",
    fill: "#0095E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6395 4.49834H6.49585V15.1603H13.6395V4.49834Z",
    fill: "#12CDF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92456 4.59333H5.07391V18.1005H5.92456V4.59333Z",
    fill: "#088BBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1326 19.2157V2.2717C14.1326 2.06452 13.991 1.88351 13.7896 1.8334L6.48568 0.0136446C6.20038 -0.0574104 5.92407 0.157998 5.92407 0.451942V19.2157C5.92407 19.3234 6.01168 19.4109 6.11951 19.4109H13.9371C14.0449 19.4102 14.1326 19.3234 14.1326 19.2157ZM6.84437 5.16027H13.3104V6.11615H6.84437V5.16027ZM6.84437 6.75265H13.3104V7.70853H6.84437V6.75265ZM6.84437 8.34503H13.3104V9.30091H6.84437V8.34503ZM6.84437 9.93741H13.3104V10.8933H6.84437V9.93741ZM6.84437 11.5298H13.3104V12.4857H6.84437V11.5298ZM6.84437 13.1222H13.3553V14.0781H6.84437V13.1222Z",
    fill: "#00B8EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurer);
export default __webpack_public_path__ + "static/media/insurer.43f2f8e2c9dd0ac9bb49110adfe87eeb.svg";
export { ForwardRef as ReactComponent };